export default __webpack_public_path__ + "static/media/dropdown_button_dots_black.7c25a79c.svg";